/*eslint no-script-url: 0 */
import React, { Component } from "react";
import Slider from 'react-slick';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';

export default class MatSelection extends Component {

	selectMat = (mat, size) => {
		let mSize = size;
		if ( mSize === null ) {
			mSize = this.props.selectedMatSize;
		}

        if (parseFloat(mSize) === 0) {
            this.props.dispatch({
                type: 'SET_STATE',
                state: {
                    selectedMatSize: 1
                }
            });
        }

		if ( parseFloat(mSize) === 1 || parseFloat(mSize) === 0 ) {
            this.props.dispatch({
                type: 'SET_STATE',
                state: {
                    selectedTopMat: mat
                }
            });
        } else if ( parseFloat(mSize) === 2 ) {
            this.props.dispatch({
                type: 'SET_STATE',
                state: {
                    selectedMiddleMat: mat
                }
            });
        } else if ( parseFloat(mSize) === 3 ) {
            this.props.dispatch({
                type: 'SET_STATE',
                state: {
                    selectedBottomMat: mat
                }
            });
        }
    };

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.selectedMatSize !== this.props.selectedMatSize) {
            const { mats, selectedMatSize, selectedTopMat, selectedMiddleMat, selectedBottomMat } = this.props;
            if ( parseFloat(selectedMatSize) === 1 && selectedTopMat.size === 0 ) {
                this.selectMat(mats.getIn([0]), 1);
            } else if ( parseFloat(selectedMatSize) === 2 && selectedMiddleMat.size === 0 ) {
                this.selectMat(mats.getIn([1]), 2);
                if (selectedTopMat.size === 0) {
                	this.selectMat(mats.getIn([0]), 1);
                }
            } else if ( parseFloat(selectedMatSize) === 3 && selectedBottomMat.size === 0 ) {
                this.selectMat(mats.getIn([2]), 3);
                if (selectedTopMat.size === 0) {
                	this.selectMat(mats.getIn([0]), 1);
                }
                if (selectedMiddleMat.size === 0) {
                	this.selectMat(mats.getIn([1]), 2);
                }
            }
        }
    }

    render() {
        const { viewportWidth, mats } = this.props;
        let slidedShow = 8;
        if (viewportWidth < 1024) {
            slidedShow = 5
        }
        var settings = {
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: mats.size <= slidedShow ? mats.size : slidedShow,
            slidesToScroll: slidedShow,
            lazyLoad: true,
            pauseOnHover: true
        };
        return (
        	<div className="col-sm-12">
	            <Slider {...settings}>
	                {mats.map( (mat) =>
	                    <div key={mat.get('id')}>
                            <MatSelected
                                {...this.props}
                                mat={mat}
                                selectMat={this.selectMat} />
	                    </div>
	                )}
	            </Slider>
		    </div>
        );
    }
}

class MatSelected extends Component {

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.selectedMatSize !== this.props.selectedMatSize) {
            this.props.dispatch({
                type: 'SET_STATE',
                state: {
                    matView: 0
                }
            });
        }
    }

    render() {
        const { selectedTopMat, selectedMiddleMat, selectedBottomMat, mat, selectedMatSize, matView } = this.props;
        let matViewSelect = matView;
        let classNames1 = '';
        if ( parseFloat(matViewSelect) === 0 ) {
            matViewSelect = selectedMatSize
        }
        if (parseFloat(selectedMatSize) === 0) {
            classNames1 = '';
        }
        if ( (parseFloat(selectedMatSize) === 1 || parseFloat(matViewSelect) === 1) && selectedTopMat.get('id') === mat.get('id') ) {
            classNames1 = 'selectedImageFrame';
        }
        if ( (parseFloat(selectedMatSize) === 2 || parseFloat(matViewSelect) === 2) && selectedMiddleMat.get('id') === mat.get('id') ) {
            classNames1 = 'selectedImageFrame';
        }
        if ( (parseFloat(selectedMatSize) === 3 || parseFloat(matViewSelect) === 3) && selectedBottomMat.get('id') === mat.get('id') ) {
            classNames1 = 'selectedImageFrame';
        }

        const tooltip = (
            <Tooltip id="tooltip">
                {mat.getIn(['title', 'rendered'])}
            </Tooltip>
        );

        return (
            <div className="frm_box mats_frm_bx">
                <OverlayTrigger placement="bottom" overlay={tooltip}>
                    <a href="#!" onClick={this.props.selectMat.bind(this, mat, matViewSelect)} className={classNames1}>
                        <svg version="1.1" viewBox="0 0 72 102.1">
                            <g>
                                <polygon className="st0" points="6.5,101.5 0.5,98.2 0.5,10.9 6.5,15.8"/>
                                <polygon className="st0" points="38.5,4.3 32,0.5 0.5,10.9 6.5,15.8"/>
                                <polygon className="st1" style={{fill: mat.getIn(['acf', 'color'])}} points="38.5,55.3 38.5,4.3 6.5,15.8 6.5,67.7 6.5,101.5 71.4,77.4 71.5,42.5"/>
                                <polygon className="st0" points="71.5,42.5 65.2,40.3 38.5,49.9 38.5,55.3"/>
                            </g>
                        </svg>
                    </a>
                </OverlayTrigger>
                {classNames1 === 'selectedImageFrame' &&
                    <div className="arrow-up-mat"></div>
                }
            </div>
        );
    }
}